import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLogOut, FiShield, FiUser, FiActivity } from 'react-icons/fi';
import { toast } from 'react-hot-toast';

export default function Layout({ children }) {
  const navigate = useNavigate();
  const [user] = useState(JSON.parse(localStorage.getItem('user') || '{}'));

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
    toast.success('Logged out successfully');
  };

  return (
    <div className="min-h-screen">
      <nav className="glass-card sticky top-4 mx-4 z-50 backdrop-blur-xl bg-opacity-80">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary to-orange-500 flex items-center justify-center">
                <FiShield className="text-darker text-xl" />
              </div>
              <div>
                <h1 className="text-xl font-bold">Digital Liberia</h1>
                <p className="text-xs text-gray-400">Identity Verification System</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-6">
              <button 
                onClick={() => navigate('/')}
                className="text-gray-300 hover:text-primary transition-colors flex items-center space-x-2"
              >
                <FiActivity />
                <span>Dashboard</span>
              </button>
              <button 
                onClick={() => navigate('/verify')}
                className="text-gray-300 hover:text-primary transition-colors flex items-center space-x-2"
              >
                <FiUser />
                <span>Verify</span>
              </button>
              <div className="flex items-center space-x-3 pl-6 border-l border-gray-700">
                <div className="text-right">
                  <p className="text-sm font-medium">{user.name || 'Institution User'}</p>
                  <p className="text-xs text-gray-400">{user.institution || 'Verified Partner'}</p>
                </div>
                <button 
                  onClick={handleLogout}
                  className="text-gray-400 hover:text-red-400 transition-colors"
                >
                  <FiLogOut />
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto px-6 py-8">
        {children}
      </main>
    </div>
  );
}
